// extracted by mini-css-extract-plugin
export var container = "CareerCard-module--container--Bk5BJ";
export var animation = "CareerCard-module--animation--aho4B";
export var ruleIcon = "CareerCard-module--rule-icon--unoHu";
export var content = "CareerCard-module--content--2JMSB";